import input from '@material-ui/core/Input';
import styled from 'styled-components';

const StyledSearchInput = styled(input)`
        & .stolo-site-search {
            border: 0;
            color:  ${props => props.theme.palette.common.text};
            display: block;
            padding: ${props => props.theme.space[2]} ${props => props.theme.space[2]} ${props => props.theme.space[2]} ${props => props.theme.space[8]};
            line-height: 1;
            box-shadow: none;
            width: 100%;
            box-sizing: border-box;
        }
        
        &.stolo-site-searchroot {
           width: 100%;
           font-family: ${props => props.theme.font};
        }
        
        &:focus {
          border: none;
          box-shadow: none;
        }
    `;

export default StyledSearchInput;



// WEBPACK FOOTER //
// ./src/components/styles/SearchInput.js